export default function (context, {value, field}) {
    context.dispatch('settings/filter_change', {
        value,
        name: 'osv',
        field,
        filter: context.getters.filter
    }, {root: true});
}